'use client';

import { StoreContext } from '@/components/providers/store.provider';
import { type ReactElement, useContext } from 'react';
import dynamic from 'next/dynamic';
import { observer } from 'mobx-react-lite';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import Actions from './components/actions';

const Login = dynamic(() => import('./components/login'), {
  loading: () => <LoadingSpinner />,
});
const Account = dynamic(() => import('./components/account'), {
  loading: () => <LoadingSpinner />,
});

export default observer(function AuthButton(): ReactElement {
  const { userStore } = useContext(StoreContext);

  return (
    <div className="w-fit flex flex-row items-center justify-center gap-2.5">
      <Actions />
      {!userStore.user ? <Login /> : <Account user={userStore.user} />}
    </div>
  );
});
